import { render, staticRenderFns } from "./ChooseLanguageModal.vue?vue&type=template&id=34c9ab92&scoped=true&"
import script from "./ChooseLanguageModal.vue?vue&type=script&lang=js&"
export * from "./ChooseLanguageModal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseLanguageModal.vue?vue&type=style&index=0&id=34c9ab92&prod&lang=scss&scoped=true&"
import style1 from "./ChooseLanguageModal.vue?vue&type=style&index=1&id=34c9ab92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c9ab92",
  null
  
)

export default component.exports